// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Map = require("rescript/lib/js/belt_Map.js");
var MM_parser = require("./MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("./MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var MM_asrt_apply = require("./MM_asrt_apply.bs.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Belt_MutableMap = require("rescript/lib/js/belt_MutableMap.js");
var Belt_MutableSet = require("rescript/lib/js/belt_MutableSet.js");
var MM_substitution = require("./MM_substitution.bs.js");
var Expln_utils_data = require("@expln/utils/src/main/Expln_utils_data.bs.js");
var Belt_MutableQueue = require("rescript/lib/js/belt_MutableQueue.js");
var Belt_MutableMapInt = require("rescript/lib/js/belt_MutableMapInt.js");
var Expln_utils_common = require("@expln/utils/src/main/Expln_utils_common.bs.js");
var MM_progress_tracker = require("../utils/MM_progress_tracker.bs.js");

function createEmptyProofTree(frms, hyps, maxVar, disj, parenCnt) {
  return {
          frms: frms,
          hypsByExpr: Belt_Map.fromArray(Belt_MapString.toArray(hyps).map(function (param) {
                    var hyp = param[1];
                    return [
                            hyp.expr,
                            hyp
                          ];
                  }), MM_context.ExprCmp),
          hypsByLabel: hyps,
          maxVar: maxVar,
          newVars: Belt_MutableSet.make(MM_context.ExprCmp),
          disj: disj,
          parenCnt: parenCnt,
          rootNodes: Belt_MutableMap.make(MM_context.ExprCmp),
          nodes: Belt_MutableMap.make(MM_context.ExprCmp)
        };
}

function createOrUpdateNode(tree, label, expr, child) {
  var node = Belt_MutableMap.get(tree.nodes, expr);
  var result;
  if (node !== undefined) {
    result = node;
  } else {
    var node$1 = {
      expr: expr,
      label: label,
      parents: undefined,
      children: [],
      proof: undefined
    };
    Belt_MutableMap.set(tree.nodes, expr, node$1);
    result = node$1;
  }
  if (child !== undefined && !MM_context.exprEq(expr, child.expr)) {
    var match = result.children.find(function (existingChild) {
          return MM_context.exprEq(existingChild.expr, child.expr);
        });
    if (match !== undefined) {
      
    } else {
      result.children.push(child);
    }
  }
  return result;
}

function markProved(node) {
  var getProofFromParents = function (node) {
    var parents = node.parents;
    if (parents !== undefined) {
      return Expln_utils_common.arrForEach(parents, (function (parent) {
                    if (typeof parent === "number" || parent.TAG === /* Hypothesis */0 || parent.args.every(function (arg) {
                            return Belt_Option.isSome(arg.proof);
                          })) {
                      return parent;
                    }
                    
                  }));
    }
    
  };
  var nodeProof = getProofFromParents(node);
  if (nodeProof === undefined) {
    return ;
  }
  node.proof = nodeProof;
  var nodesToMarkProved = Belt_MutableQueue.fromArray(node.children);
  while(Belt_MutableQueue.size(nodesToMarkProved) > 0) {
    var curNode = Belt_Option.getExn(Belt_MutableQueue.pop(nodesToMarkProved));
    if (Belt_Option.isNone(curNode.proof)) {
      var curNodeProof = getProofFromParents(curNode);
      if (curNodeProof !== undefined) {
        curNode.proof = curNodeProof;
        curNode.children.forEach(function (param) {
              return Belt_MutableQueue.add(nodesToMarkProved, param);
            });
      }
      
    }
    
  };
}

function getStatementsFromJustification(tree, stmts, justification) {
  var getStmtByLabel = function (label) {
    var stmt = stmts.find(function (param) {
          var stmtLabel = param.label;
          if (stmtLabel !== undefined) {
            return stmtLabel === label;
          } else {
            return false;
          }
        });
    if (stmt !== undefined) {
      return stmt.expr;
    }
    var hyp = Belt_MapString.get(tree.hypsByLabel, label);
    if (hyp !== undefined) {
      return hyp.expr;
    }
    
  };
  var foundStmts = justification.args.map(getStmtByLabel).filter(Belt_Option.isSome).map(Belt_Option.getExn);
  if (foundStmts.length === justification.args.length) {
    return foundStmts;
  } else {
    return [];
  }
}

function proveNode(tree, stmts, node, justification, syntaxProof, allowEmptyArgs) {
  var prevRootExprs = stmts.map(function (param) {
        return param.expr;
      });
  var nodesToCreateParentsFor = Belt_MutableQueue.make(undefined);
  var addParentsWithoutNewVars = function (node) {
    Belt_MapString.forEach(tree.frms, (function (param, frm) {
            if (!Belt_Option.isNone(node.proof)) {
              return ;
            }
            var frmExpr = frm.frame.asrt;
            var expr = node.expr;
            if (Caml_array.get(frmExpr, 0) === Caml_array.get(expr, 0)) {
              MM_substitution.iterateSubstitutions(frmExpr, expr, Caml_array.get(frm.frmConstParts, frm.numOfHypsE), Caml_array.get(frm.constParts, frm.numOfHypsE), Caml_array.get(frm.varGroups, frm.numOfHypsE), frm.subs, tree.parenCnt, (function (subs) {
                      var tmp = false;
                      if (subs.isDefined.every(function (b) {
                              return b;
                            })) {
                        var partial_arg = tree.disj;
                        tmp = MM_substitution.verifyDisjoints(frm.frame.disj, subs, (function (param, param$1) {
                                return MM_context.disjContains(partial_arg, param, param$1);
                              }));
                      }
                      if (tmp) {
                        var args = frm.frame.hyps.map(function (hyp) {
                              var newExprToProve = MM_substitution.applySubs(hyp.expr, subs, (function (param) {
                                      throw {
                                            RE_EXN_ID: MM_parser.MmException,
                                            _1: {
                                              msg: "Work variables are not supported in addParentsWithoutNewVars()."
                                            },
                                            Error: new Error()
                                          };
                                    }));
                              var arg = createOrUpdateNode(tree, undefined, newExprToProve, node);
                              Belt_MutableQueue.add(nodesToCreateParentsFor, arg);
                              return arg;
                            });
                        var parent_1 = frm.frame.label;
                        var parent = {
                          TAG: /* Assertion */1,
                          args: args,
                          label: parent_1
                        };
                        Belt_Option.getExn(node.parents).push(parent);
                        markProved(node);
                      }
                      if (Belt_Option.isNone(node.proof)) {
                        return /* Continue */0;
                      } else {
                        return /* Stop */1;
                      }
                    }));
              return ;
            }
            
          }));
  };
  if (syntaxProof) {
    Belt_MutableQueue.add(nodesToCreateParentsFor, node);
    while(Belt_Option.isNone(node.proof) && Belt_MutableQueue.size(nodesToCreateParentsFor) > 0) {
      var curNode = Belt_Option.getExn(Belt_MutableQueue.pop(nodesToCreateParentsFor));
      var match = curNode.parents;
      if (match === undefined) {
        if (Belt_MutableSet.has(tree.newVars, curNode.expr)) {
          curNode.parents = [/* VarType */0];
          markProved(curNode);
        } else {
          var hyp = Belt_Map.get(tree.hypsByExpr, curNode.expr);
          if (hyp !== undefined) {
            curNode.parents = [{
                TAG: /* Hypothesis */0,
                label: hyp.label
              }];
            markProved(curNode);
          } else {
            curNode.parents = [];
            addParentsWithoutNewVars(curNode);
          }
        }
      }
      
    };
    return ;
  }
  node.parents = [];
  var applResults = [];
  if (justification !== undefined) {
    var partial_arg = tree.disj;
    MM_asrt_apply.applyAssertions(tree.maxVar, tree.frms, (function (param, param$1) {
            return MM_context.disjContains(partial_arg, param, param$1);
          }), getStatementsFromJustification(tree, stmts, justification), true, allowEmptyArgs, node.expr, tree.parenCnt, (function (frame) {
            return frame.label === justification.asrt;
          }), (function (res) {
            applResults.push(res);
            return /* Continue */0;
          }), undefined, undefined);
  } else {
    var partial_arg$1 = tree.disj;
    MM_asrt_apply.applyAssertions(tree.maxVar, tree.frms, (function (param, param$1) {
            return MM_context.disjContains(partial_arg$1, param, param$1);
          }), prevRootExprs, undefined, allowEmptyArgs, node.expr, tree.parenCnt, undefined, (function (res) {
            applResults.push(res);
            return /* Continue */0;
          }), undefined, undefined);
  }
  Expln_utils_common.arrForEach(applResults, (function (applResult) {
          var applNewVarToTreeNewVar = Belt_MutableMapInt.make(undefined);
          applResult.newVars.forEach(function (v, i) {
                tree.maxVar = tree.maxVar + 1 | 0;
                var newVar = tree.maxVar;
                Belt_MutableMapInt.set(applNewVarToTreeNewVar, v, newVar);
                var newVarType = Caml_array.get(applResult.newVarTypes, i);
                Belt_MutableSet.add(tree.newVars, [
                      newVarType,
                      newVar
                    ]);
              });
          MM_context.disjForEach(applResult.newDisj, (function (n, m) {
                  MM_context.disjAddPair(tree.disj, Belt_MutableMapInt.getWithDefault(applNewVarToTreeNewVar, n, n), Belt_MutableMapInt.getWithDefault(applNewVarToTreeNewVar, m, m));
                }));
          var frm = Belt_MapString.get(tree.frms, applResult.asrtLabel);
          var frame;
          if (frm !== undefined) {
            frame = frm.frame;
          } else {
            throw {
                  RE_EXN_ID: MM_parser.MmException,
                  _1: {
                    msg: "Cannot find an assertion with label " + applResult.asrtLabel + " in addParentsWithNewVars."
                  },
                  Error: new Error()
                };
          }
          var args = frame.hyps.map(function (hyp) {
                var argExpr = MM_substitution.applySubs(hyp.expr, applResult.subs, (function (param) {
                        throw {
                              RE_EXN_ID: MM_parser.MmException,
                              _1: {
                                msg: "New work variables are not expected here."
                              },
                              Error: new Error()
                            };
                      }));
                var existingNode = Belt_MutableMap.get(tree.rootNodes, argExpr);
                if (existingNode !== undefined) {
                  return existingNode;
                } else {
                  return createOrUpdateNode(tree, undefined, argExpr, node);
                }
              });
          if (checkTypes(tree, frame, args)) {
            args.forEach(function (arg) {
                  if (Belt_Option.isNone(arg.parents)) {
                    return Belt_MutableQueue.add(nodesToCreateParentsFor, arg);
                  }
                  
                });
            Belt_Option.getExn(node.parents).push({
                  TAG: /* Assertion */1,
                  args: args,
                  label: applResult.asrtLabel
                });
            markProved(node);
          }
          if (Belt_Option.isSome(node.proof)) {
            return true;
          }
          
        }));
}

function checkTypes(tree, frame, args) {
  var nodesToTypecheck = [];
  frame.hyps.forEach(function (hyp, hypIdx) {
        if (hyp.typ === /* F */0) {
          nodesToTypecheck.push(Caml_array.get(args, hypIdx));
          return ;
        }
        
      });
  return nodesToTypecheck.every(function (node) {
              proveNode(tree, [], node, undefined, true, false);
              return Belt_Option.isSome(node.proof);
            });
}

function proofTreeProve(ctx, frms, stmts, parenCnt, syntaxProof, allowEmptyArgsOpt, onProgress, param) {
  var allowEmptyArgs = allowEmptyArgsOpt !== undefined ? allowEmptyArgsOpt : false;
  var stmtsProcessed = 0;
  var progressState = MM_progress_tracker.progressTrackerMake(0.01, undefined, onProgress, undefined, undefined);
  var maxVar = MM_context.getNumOfVars(ctx) - 1 | 0;
  var disj = MM_context.getAllDisj(ctx);
  var hyps = MM_context.getAllHyps(ctx);
  var tree = createEmptyProofTree(frms, hyps, maxVar, disj, parenCnt);
  MM_context.getLocalHyps(ctx).forEach(function (hyp) {
        var rootNode = createOrUpdateNode(tree, hyp.label, hyp.expr, undefined);
        rootNode.proof = {
          TAG: /* Hypothesis */0,
          label: hyp.label
        };
        Belt_MutableMap.set(tree.rootNodes, rootNode.expr, rootNode);
      });
  var numOfStmts = stmts.length;
  for(var stmtIdx = 0; stmtIdx < numOfStmts; ++stmtIdx){
    Belt_MutableMap.clear(tree.nodes);
    var rootNode = createOrUpdateNode(tree, Caml_array.get(stmts, stmtIdx).label, Caml_array.get(stmts, stmtIdx).expr, undefined);
    Belt_MutableMap.set(tree.rootNodes, rootNode.expr, rootNode);
    proveNode(tree, Belt_MutableMap.valuesToArray(tree.rootNodes).map(function (node) {
              return {
                      label: node.label,
                      expr: node.expr,
                      justification: undefined
                    };
            }), rootNode, Caml_array.get(stmts, stmtIdx).justification, syntaxProof, allowEmptyArgs);
    stmtsProcessed = stmtsProcessed + 1;
    progressState = MM_progress_tracker.progressTrackerSetCurrPct(progressState, stmtsProcessed / numOfStmts);
  }
  return tree;
}

function proofTreeCreateProofTable(node) {
  var processedExprs = Belt_MutableSet.make(MM_context.ExprCmp);
  var exprToIdx = Belt_MutableMap.make(MM_context.ExprCmp);
  var tbl = [];
  Expln_utils_data.traverseTree(undefined, node, (function (param, n) {
          var match = n.proof;
          if (match !== undefined) {
            if (typeof match !== "number") {
              if (match.TAG === /* Hypothesis */0 || Belt_MutableSet.has(processedExprs, n.expr)) {
                return ;
              } else {
                return match.args;
              }
            }
            throw {
                  RE_EXN_ID: MM_parser.MmException,
                  _1: {
                    msg: "VarType is not supported in createProofTable [1]."
                  },
                  Error: new Error()
                };
          }
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "Cannot create proofTable from an unproved proofTreeNode [1]."
                },
                Error: new Error()
              };
        }), undefined, (function (param, n) {
          var match = n.proof;
          if (match !== undefined) {
            if (typeof match === "number") {
              throw {
                    RE_EXN_ID: MM_parser.MmException,
                    _1: {
                      msg: "VarType is not supported in createProofTable [2]."
                    },
                    Error: new Error()
                  };
            }
            if (match.TAG === /* Hypothesis */0 && Belt_Option.isNone(Belt_MutableMap.get(exprToIdx, n.expr))) {
              var idx = tbl.push({
                    expr: n.expr,
                    proof: {
                      TAG: /* Hypothesis */0,
                      label: match.label
                    }
                  }) - 1 | 0;
              Belt_MutableMap.set(exprToIdx, n.expr, idx);
            }
            
          } else {
            throw {
                  RE_EXN_ID: MM_parser.MmException,
                  _1: {
                    msg: "Cannot create proofTable from an unproved proofTreeNode [2]."
                  },
                  Error: new Error()
                };
          }
        }), (function (param, n) {
          var match = n.proof;
          if (match !== undefined) {
            if (typeof match === "number") {
              throw {
                    RE_EXN_ID: MM_parser.MmException,
                    _1: {
                      msg: "VarType is not supported in createProofTable [3]."
                    },
                    Error: new Error()
                  };
            }
            if (match.TAG !== /* Hypothesis */0 && Belt_Option.isNone(Belt_MutableMap.get(exprToIdx, n.expr))) {
              var idx = tbl.push({
                    expr: n.expr,
                    proof: {
                      TAG: /* Assertion */1,
                      args: match.args.map(function (n) {
                            return Belt_Option.getWithDefault(Belt_MutableMap.get(exprToIdx, n.expr), -1);
                          }),
                      label: match.label
                    }
                  }) - 1 | 0;
              Belt_MutableMap.set(exprToIdx, n.expr, idx);
            }
            
          } else {
            throw {
                  RE_EXN_ID: MM_parser.MmException,
                  _1: {
                    msg: "Cannot create proofTable from an unproved proofTreeNode [3]."
                  },
                  Error: new Error()
                };
          }
        }), undefined);
  return tbl;
}

exports.proofTreeProve = proofTreeProve;
exports.proofTreeCreateProofTable = proofTreeCreateProofTable;
/* MM_context Not a pure module */
